import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import { FundService } from '../../services/fund.service'
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-format-pdf-save',
  templateUrl: './format-pdf-save.component.html',
  styleUrls: ['./format-pdf-save.component.scss']
})
export class FormatPdfSaveComponent implements OnInit {

  constructor(private route: ActivatedRoute, private _fundInfoService: FundService,) { }
  FunbId: any
  dateTab4: any
  Tab4Total: any
  Tab4PDF: any

  async ngOnInit() {

    await this.route.params.subscribe(params => {
      this.FunbId = params['id'];
      this.dateTab4 = params['date'];

      this._fundInfoService.GetPDFBasket(params['id'], this.dateTab4).subscribe(response => {
        this.Tab4PDF = response['Result']
        var x = 0;
        var i: number;
        for (i = 0; i < response['Result'].length; i++) {
          var y = +response['Result'][i]["Result"]
          x = x + y
        }
        this.Tab4Total = x
      })
    })

    setTimeout(() => {
    this.save();
    },
      1800);
  }

  async save() {
    const options = {
      filename: "export-pdf.pdf",
      image: { type: 'pdf', quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true },
      margin: [10, 5, 0, 5],
      jsPDF: {
        unit: 'pt',
        width: 595,
        format: 'a4',
        orientation: 'portrait'
      }
    };
    const content: Element = document.getElementById('pdfBasket');
    await html2pdf().from(content).set(options).save();

    setTimeout(() => {
      window.close();
    },
      1500);
  }
}
